(() => {
 let busy = false;
 document.addEventListener('click', async event => {
  const button = event.target.closest('[data-routine-add]');
  if (!button) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (busy) return;
  const offer = button.closest('.routine-offer');
  const select = offer.querySelector('[data-routine-variant]');
  if (!select.reportValidity()) return;
  const status = offer.querySelector('[data-routine-status]');
  const config = document.getElementById('routine-config');
  if (!config) return;
  busy = true;
  button.disabled = true;
  offer.setAttribute('aria-busy', 'true');
  try {
   const cartResponse = await fetch(config.dataset.cart + '.js', {cache:'no-store'});
   if (!cartResponse.ok) throw new Error(config.dataset.error);
   const cart = await cartResponse.json();
   const productLink = offer.querySelector('a').getAttribute('href');
   const productHandle = productLink.split('/').filter(Boolean).pop();
   if (cart.items.some(item => item.handle === productHandle)) {
    window.location.assign(config.dataset.cart);
    return;
   }
   const response = await fetch(config.dataset.add + '.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:Number(select.value),quantity:1}]})});
   const result = await response.json();
   if (!response.ok) throw new Error(result.description || config.dataset.error);
   window.location.assign(config.dataset.cart);
  } catch (error) {
   status.textContent = '';
   requestAnimationFrame(() => { status.textContent = error.message || config.dataset.error; });
   busy = false;
   button.disabled = false;
   offer.removeAttribute('aria-busy');
  }
 }, true);
})();
(() => {
 let timer;
 let controller;
 window.addEventListener('listCart', () => {
  clearTimeout(timer);
  timer = setTimeout(async () => {
   const region = document.querySelector('[data-routine-region][data-product-page="true"]');
   const section = region?.closest('[id^="shopify-section-"]');
   if (!section) return;
   controller?.abort();
   controller = new AbortController();
   try {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));
    const response = await fetch(url, {signal:controller.signal,cache:'no-store'});
    if (!response.ok) return;
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const fresh = doc.querySelector('[data-routine-region][data-product-page="true"]');
    if (fresh && !region.contains(document.activeElement)) region.replaceWith(fresh);
   } catch (error) { if (error.name !== 'AbortError') console.warn('Routine offer refresh failed'); }
  }, 200);
 });
 const expire = () => {
  document.querySelectorAll('[data-shipping-offer-end]').forEach(node => {
   if (Date.now() >= Date.parse(node.dataset.shippingOfferEnd)) node.remove();
  });
 };
 expire();
 setInterval(expire, 30000);
})();
